var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaywallsinline = function SvgPaywallsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 6.672c.287 0 .52.22.52.487a.47.47 0 0 1-.108.296.53.53 0 0 1-.279.174.56.56 0 0 1-.334-.02.5.5 0 0 1-.252-.207.5.5 0 0 0-.135-.142.54.54 0 0 0-.386-.095.55.55 0 0 0-.345.188.47.47 0 0 0-.102.361q.015.097.067.18c.187.302.49.516.833.633v.297c0 .268.235.487.521.487s.52-.22.52-.487v-.292c.305-.1.569-.286.755-.532s.287-.54.287-.84c0-.804-.703-1.461-1.562-1.461a.54.54 0 0 1-.368-.143.47.47 0 0 1-.153-.344c0-.107.038-.212.108-.297a.53.53 0 0 1 .28-.174.56.56 0 0 1 .335.02.5.5 0 0 1 .252.208q.052.083.134.142a.54.54 0 0 0 .386.095.55.55 0 0 0 .346-.188.47.47 0 0 0 .101-.362.5.5 0 0 0-.067-.18 1.53 1.53 0 0 0-.833-.632v-.297c0-.267-.235-.486-.521-.486s-.52.219-.52.486v.292c-.305.1-.569.286-.755.532s-.287.54-.287.841c0 .803.703 1.46 1.562 1.46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.186,
    r: 5.025,
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.75 15.228h6.5v.2h-6.5zM6.75 13.144h6.5v.2h-6.5zM2.375 19.603h6.5v.2h-6.5zM2.375 17.519h6.5v.2h-6.5zM11.125 19.603h6.5v.2h-6.5zM11.125 17.519h6.5v.2h-6.5z"
  })));
};
export default SvgPaywallsinline;